import React, { useEffect, useState } from 'react';

import ModalBanner from '../../ModalBanner';

import CloseButton from '../../Reutilizaveis/CloseButton';
import AditivoAssinadoSucesso from './AditivoAssinadoSucesso';

import { SignatureDiv } from './styles';

import portalEnvironment from '../../../Utils/baseURL';

const AditivoRenegociacao = ({
  showDocToSign,
  handleShowDocToSign,
  tema,
  dadosDocSign,
  getParcelas,
}) => {
  const [aditivoAssinadoSucesso, setAditivoAssinadoSucesso] = useState(false);

  var key = dadosDocSign?.envelopeId;

  var signer_disable_preview = '0';
  var signer_email = encodeURIComponent(dadosDocSign?.email);

  var signer_display_name = '';
  var signer_documentation = '';
  var signer_birthday = '';
  var signer_key_signer = '';

  var host = `${portalEnvironment.BaseUrlD4Sign}/viewblob`;
  var container = 'signature-div';
  var width = '100%';
  var height = '500';

  var is_safari = navigator.userAgent.indexOf('Safari') > -1;
  var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;

  let iframe = document.createElement('iframe');
  useEffect(() => {
    if (is_chrome && is_safari) {
      is_safari = false;
    }
    if (is_safari) {
      if (!document.cookie.match(/^(.*;)?\s*fixed\s*=\s*[^;]+(.*)?$/)) {
        document.cookie =
          'fixed=fixed; expires=Tue, 19 Jan 2038 03:14:07 UTC; path=/';
        var url = document.URL;
        var str = window.location.search;
        var param = str.replace('?', '');
        if (url.indexOf('?') > -1) {
          url = url.substr(0, url.indexOf('?'));
        }
        window.location.replace(
          `${portalEnvironment.BaseUrlD4Sign}/safari_fix?param=${param}&r=${url}`
        );
      }
    }

    if (signer_key_signer === '') {
      iframe.setAttribute(
        'src',
        host +
          '/' +
          key +
          '?email=' +
          signer_email +
          '&display_name=' +
          signer_display_name +
          '&documentation=' +
          signer_documentation +
          '&birthday=' +
          signer_birthday +
          '&disable_preview=' +
          signer_disable_preview
      );
    } else {
      iframe.setAttribute(
        'src',
        host +
          '/' +
          key +
          '?email=' +
          signer_email +
          '&display_name=' +
          signer_display_name +
          '&documentation=' +
          signer_documentation +
          '&birthday=' +
          signer_birthday +
          '&disable_preview=' +
          signer_disable_preview +
          '&key_signer=' +
          signer_key_signer
      );
    }

    iframe.setAttribute('id', 'd4signIframe');
    iframe.setAttribute('width', width);
    iframe.setAttribute('height', height);

    iframe.style.border = 0;

    iframe.setAttribute('allow', 'geolocation');
    var cont = document.getElementById(container);

    cont?.appendChild(iframe);
  }, []);

  window.addEventListener(
    'message',
    (event) => {
      if (event.data === 'signed') {
        setAditivoAssinadoSucesso(true);
      }

      if (event.data === 'wrong-data') {
        console.log('DADOS ERRADOS');
      }
    },
    false
  );

  async function handleSuccess() {
    handleShowDocToSign();
    await getParcelas();
  }

  return (
    <>
      {aditivoAssinadoSucesso && (
        <AditivoAssinadoSucesso handleSuccess={handleSuccess} tema={tema} />
      )}
      {!aditivoAssinadoSucesso && (
        <ModalBanner showBanner={showDocToSign}>
          <SignatureDiv id='signature-div'>
            <div
              style={{
                position: 'absolute',
                right: '-18px',
                top: '-18px',
              }}
              id='close-aditivo'
            >
              <CloseButton
                tamanho={'36px'}
                onClick={handleShowDocToSign}
                corBackground={'#ffffff'}
              />
            </div>
          </SignatureDiv>
        </ModalBanner>
      )}
    </>
  );
};

export default AditivoRenegociacao;
